import Api from '@/services/Api'
const path = 'types'

export default {
    index(description, page) {
        return Api().get(path, {
            params: {
                description,
                page
            }
        })
    },
    show(id) {
        return Api().get(path + `/${id}`)
    },
    addUpdate(type) {
        return Api().post(path, type)
    },
    // delete(id) {
    //     return Api().delete(path + `/${id}`)
    // },
    delete(id) {
        return Api().get(path + `/delete/${id}`)
    }
}